import { Button, Space } from 'antd';
import type { UserType } from '@/pages/POS/types';

interface Props {
  value: UserType;
  onChange: (v: UserType) => void;
}

const OPTIONS: { label: string; value: UserType }[] = [
  { label: 'Cá nhân', value: 'personal' as UserType },
  { label: 'Tổ chức', value: 'organization' as UserType },
];

export function UserTypeToggle({ value, onChange }: Props) {
  return (
    <Space.Compact block>
      {OPTIONS.map((opt) => (
        <Button
          key={opt.value}
          type={value === opt.value ? 'primary' : 'default'}
          onClick={() => onChange(opt.value)}
          size="small"
          style={{ flex: 1 }}
        >
          {opt.label}
        </Button>
      ))}
    </Space.Compact>
  );
}
